import React, { useState } from 'react';


const Sidebar = ({ setActiveTab }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => setCollapsed(!collapsed);

  const navItems = [
    { key: 'home', icon: '🏠', label: 'Home' },
   // { key: 'findCreators', icon: '🔎', label: 'Find Collaborators' }, // ✅ make sure this exists after Profile # grows
    { key: 'profileReview', icon: '👤', label: 'My Profile' }
   // { key: 'invites', icon: '✉️', label: 'Invites' },
   // { key: 'projects', icon: '📁', label: 'Projects' },
   // { key: 'payments', icon: '💳', label: 'Payments' }
  ];

  return (
    <div style={{
      width: collapsed ? '72px' : '240px',
      background: 'linear-gradient(to bottom, #1F1F1F, #000000)',
      padding: '16px',
      height: 'calc(100vh - 64px)',
      borderRight: '1px solid rgba(255,255,255,0.05)',
      transition: 'width 0.3s ease',
      position: 'relative',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: collapsed ? 'center' : 'flex-start',
      color: '#F3F4F6',
      marginTop: '64px', // ✅ start right below the 64px TopBar
    }}>

      {/* Toggle Button */}
<div
  onClick={toggleSidebar}
  style={{
    position: 'absolute',
    top: '35px',                     // 👈 aligns with first nav item ("Home")
    right: '-16px',                  // half outside
    zIndex: 20,
    backgroundColor: '#111827',
    border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
    color: '#F3F4F6',
    transition: 'background 0.2s ease, transform 0.2s ease'
  }}
  title={collapsed ? "Expand Navigation" : "Collapse Navigation"} // tooltip
  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#1f2937')}
  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#111827')}
>
  {/* Hamburger icon */}
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
    <span style={{ width: '14px', height: '2px', background: '#F3F4F6', borderRadius: '1px' }}></span>
    <span style={{ width: '14px', height: '2px', background: '#F3F4F6', borderRadius: '1px' }}></span>
    <span style={{ width: '14px', height: '2px', background: '#F3F4F6', borderRadius: '1px' }}></span>
  </div>
</div>

      {/* Navigation */}
      <nav style={{ width: '100%' }}>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {navItems.map((item) => (
            <li
              key={item.key}
              
              onClick={() => {
                if (setActiveTab) setActiveTab(item.key);      // ← go by tabs, not route
              }}
              
              style={{
                ...liStyle,
                justifyContent: collapsed ? 'center' : 'flex-start'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#2a2a2a'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <span style={iconStyle}>{item.icon}</span>
              {!collapsed && <span style={labelStyle}>{item.label}</span>}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

// styles
const liStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '16px',
  cursor: 'pointer',
  padding: '10px 14px',
  borderRadius: '8px',
  transition: 'background 0.2s ease',
  color: '#F3F4F6',
  flexWrap: 'nowrap',     // 👈 prevent wrapping
  width: '100%',          // 👈 ensure consistent width
  minWidth: 0             // 👈 allow ellipsis to work
};

const iconStyle = {
  fontSize: '20px',
  minWidth: '24px',
  textAlign: 'center',
  flex: '0 0 24px'        // 👈 icon stays fixed width
};

const labelStyle = {
  fontSize: '15px',
  whiteSpace: 'nowrap',   // 👈 keep on one line
  overflow: 'hidden',     // 👈 hide overflow
  textOverflow: 'ellipsis',
  flex: 1,                // 👈 take remaining space
  minWidth: 0
};

export default Sidebar;
